import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { EscalationAnalyticsService } from '../tokens/escalation-analytics.token';
import { EscalationAnalytics, PerformanceAnalytics } from '../models/escalation-analytics.model';
import { API_PATHS } from '../config/api-paths';

/**
 * REST-backed implementation of `EscalationAnalyticsService` (S-F / EM-662).
 *
 * Calls the read-only `EscalationAnalyticsResource` at
 * `/services/embedded/api/escalation-analytics`. Authenticated via the portal's
 * `authInterceptor`.
 *
 * Rule 10 — no mock fallback, no in-memory state. Playwright intercepts via `page.route()`.
 */
@Injectable()
export class EscalationAnalyticsRestService implements EscalationAnalyticsService {
  private readonly http = inject(HttpClient);

  private get base(): string {
    return `${API_PATHS.EMBEDDED_API_BASE}/escalation-analytics`;
  }

  getEscalationAnalytics(): Observable<EscalationAnalytics> {
    return this.http.get<EscalationAnalytics>(this.base);
  }

  getPerformanceAnalytics(): Observable<PerformanceAnalytics> {
    return this.http.get<PerformanceAnalytics>(`${this.base}/performance`);
  }
}
